export default function BasicData({setData, form}) {
    return (
        <>
            <div className={'col-12'}>
                Attendees: {form?.attendants ?? ''}
                <input type={"range"} className={"form-control"} placeholder={"No. of attendants"}
                       min={6}
                       max={500}
                       value={form?.attendants ?? ''}
                       onChange={(e) => setData({attendants: e.target.value})}
                />
            </div>
        </>
    );
}